define.alias("ember-math-helpers/helpers/cosh", "media/helpers/cosh");